import React from "react"; // optional on modern setups with the new JSX transform
import { Box , Tooltip,FormControl, MenuItem, Select} from "@mui/material";
import { formatAmount, TruncatedTextUptoLine, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import WidgetCard from "../createForm/WidgetCard";
import { BatchDetails, BatchDetailsWithOutGRN, SkuData, SkuDataWithoutGRN, ViewReturnBatchDetails, ViewReturnSkuData } from "./PrimaryReturnUtils";
import { ReactComponent as CircledRight } from "../../assets/image/svg/circledRight.svg";
import { ReactComponent as SubtractIcon } from "../../assets/image/svg/subtractIcon.svg";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import PrimaryReturnQtyCell from "./PrimaryReturnQtyCell";


export const ViewPrimaryReturnMetadata = (currency: string = "₹", data: any): any[] => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {caseUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn} = ConfigDictionary;
  const metaData: any[] = [
    {
      keys: "creationTime",
      label: "Return Date & Time",
      index: 1,
    },
    {
      keys: "referenceNumber",
      label: "Invoice No.",
      index: 2,
    },
    {
      keys: "grnNumber",
      label: "GRN No.",
      index: 3,
    },
    {
      keys: "supplier",
      label: "Company Supplier",
      index: 4,
    },
    {
      key: "totalReturnedQuantity",
      label: "Total Returned Quantity",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <p>
          {caseUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              {data?.totalReturnedCaseQuantity ?? 0}{" "}
              <span  >{caseUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {otherUnitLabelPrimaryReturn && (
            <span  style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedOtherUnitQuantity ?? 0}{" "}
              <span>{otherUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {packUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedPieceQuantity ?? 0} {" "}
              <span>{packUnitLabelPrimaryReturn}</span>
            </span>
          )}
        </p>
      ),
    },
    {
      key: "totalReturnValue",
      label: "Total Returned Value",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <span style={{ fontWeight: 500, color: "#1b7713" }}>
          {formatAmount(data?.totalReturnValue ?? 0, currency)}
        </span>
      ),
    }
  ];

  return metaData;
};


export const ViewPrimaryReturnWithoutGRNMetadata = (currency: string = "₹", data: any): any[] => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {caseUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn} = ConfigDictionary;
  const metaData: any[] = [
    {
      keys: "creationTime",
      label: "Return Date & Time",
      index: 1,
    },
    {
      keys: "supplier",
      label: "Company Supplier",
      index: 4,
    },
    {
      key: "totalReturnedQuantity",
      label: "Total Returned Quantity",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <p>
          {caseUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              {data?.totalReturnedCaseQuantity ?? 0}{" "}
              <span  >{caseUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {otherUnitLabelPrimaryReturn && (
            <span  style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedOtherQuantity ?? 0}{" "}
              <span>{otherUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {packUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedPieceQuantity ?? 0} {" "}
              <span>{packUnitLabelPrimaryReturn}</span>
            </span>
          )}
        </p>
      ),
    },
    {
      key: "totalReturnValue",
      label: "Total Returned Value",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <span style={{ fontWeight: 500, color: "#1b7713" }}>
          {formatAmount(data?.totalReturnValue ?? 0, currency)}
        </span>
      ),
    }
  ];

  return metaData;
};

export const EditPrimaryReturnMetadata = (data: any): any[] => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {caseUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn} = ConfigDictionary;
  const currency = ConfigDictionary?.currency ?? "";
  const metaData: any[] = [
    {
      keys: "currentDate",
      label: "Return Date",
      index: 1,
    },
    {
      keys: "invoiceNumber",
      label: "Invoice No.",
      index: 2,
    },
    {
      keys: "grnNumber",
      label: "GRN No.",
      index: 3,
    },
    {
      keys: "supplier",
      label: "Company Supplier",
      index: 4,
    },
    {
      key: "totalReturnedQuantity",
      label: "Total Returned Quantity",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <p>
          {caseUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              {data?.totalReturnedCaseQuantity ?? 0}{" "}
              <span  >{caseUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {otherUnitLabelPrimaryReturn && (
            <span  style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedOtherQuantity ?? 0}{" "}
              <span>{otherUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {packUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedPieceQuantity ?? 0} {" "}
              <span>{packUnitLabelPrimaryReturn}</span>
            </span>
          )}
        </p>
      ),
    },
    {
      key: "totalReturnValue",
      label: "Total Returned Value",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <span style={{ fontWeight: 500, color: "#1b7713"  }}>
          {formatAmount(data?.totalReturnValue ?? 0, currency)}
        </span>
      ),
    }
  ];

  return metaData;
};
export const EditPrimaryReturnConfig = (
  handleRedirect: (rowData: SkuData) => void,
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: SkuData) => void
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;

  return {
    columns: [

      {
        headerName: "skuNameAndCode",
        mappedValue: "skuCode",
        width: 180,
        renderHeader: (value: any) => (
          <Box display="flex" sx={{ flexDirection: "column", alignItems: "left" }}>
              <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                <span>{"SKU Name"}</span>
                <span className="customTableInfo_marginTopNegative">{"& Code"}</span>
              </Box>
            </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={`${row?.skuName} - ${value}`}>
              <Box className="sku_name_truncate_text">
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{ ...TruncatedTextUptoLine(1), fontWeight: 500, fontSize: "12px" }}>
                    {row?.skuName}
                  </span>
                  <span style={{ ...TruncatedTextUptoLine(1), fontSize: "11px", color: "#666" }}>
                    {value}
                  </span>
                </div>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "Pack Type",
        mappedValue: "brand",
        width: 100,
        textAlign: "left",
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box>
              <span>{"Brand"}</span>
            </Box>
          </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Box className="sku_name_truncate_text">
              <span>{row.brand}</span>
            </Box>
          );
        },
      },
       ...(batchIdConfiguration
        ? [
            {
              headerName: "Batch Id",
              mappedValue: "batchId",
              width: 120,
              canOpen: true,
              renderHeader: (value: any) => (
                <Box display={"flex"} flexDirection={"column"}>
                  <span>{"Batch ID"}</span>
                </Box>
              ),
              renderCell: (value: any, row: SkuData) => {
                if (row?.batches) return (
                   <div
                    className="view-discounts-container"
                    style={{userSelect: "none"}}
                  >
                    <span >View Batch IDs</span>
                    <CircledRight style={{ width: "10px" }} />
                  </div>
                )
                return (
                  <Tooltip title={value}>
                    <Box className="sku_name_truncate_text">
                      <span style={TruncatedTextUptoLine(2)}>
                        {value ?? "-"}
                      </span>
                    </Box>
                  </Tooltip>
                );
              },
            },
          ]
        : [
            {
              headerName: "PTD",
              mappedValue: "priceToRetailer",
              width: 100,
              textAlign: "left",
              renderCell: (value: any, row: any) => {
                return (
                  <span>{`${currency} ${truncateToTwoDecimals(row.priceToRetailer)}`}</span>
                )
              }
            },
          ]
        ),
      {
        headerName: "Returnable Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: SkuData) => {
          return (
            <PrimaryReturnQtyCell
              csQty={row.totalReturnableCases ?? 0}
              pcQty={row.totalReturnablePieces ?? 0}
              otherQty={row.totalReturnableOtherUnits ?? 0}
              otherUnitName={row.otherUnitName}
            />
          )
        }
      },
      {
        headerName: "Return Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: SkuData) => {
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
            <PrimaryReturnQtyCell
              csQty={row.newReturnedCases ?? 0}
              pcQty={row.newReturnedPieces ?? 0}
              otherQty={row.newReturnedOtherUnits ?? 0}
              otherUnitName={row.otherUnitName}
            />
            <div style={{ marginLeft: "5px", cursor: 'pointer', display: 'flex', gap: '8px', alignItems: 'center' }}
            >
              <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={() => handleRedirect(row)}>
                <RenderSvg name={"viewAndEditIcon"} customStyles={{width: "18px"}} />
              </button>
              { !batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }
            </div>
            </div>

          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "actualAmount",
        textAlign: "left",
        width: 150,
        renderCell: (value: any, row: SkuData) => {
          return (
            <span>{`${currency} ${truncateToTwoDecimals(row?.totalReturnedValue ?? 0)}`}</span>
          )
        }

      },
    ],
  };
};

export const EditPrimaryReturnExpandedRowConfig = (
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: BatchDetails) => void
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;
  return {
    columns: [
      {
        headerName: "Batch ID",
        mappedValue: "batchId",
        width: 150,
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value ?? "-"}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "MRP",
        mappedValue: "mrp",
        width: 130,
        textAlign: "left",
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.mrp)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
      {
        headerName: "PTD",
        mappedValue: "priceToRetailer",
        width: 130,
        textAlign: "left",
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.priceToRetailer)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
      {
        headerName: "Return Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: BatchDetails) => {
          //Need to populate with the quantity added from user. these are the quantity from previous generate returns
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>

              <PrimaryReturnQtyCell
                csQty={(row.newAcceptedReturnedCaseQuantity ?? 0) + (row.newRejectedReturnedCaseQuantity ?? 0)}
                pcQty={(row.newAcceptedReturnedPieceQuantity ?? 0) + (row.newRejectedReturnedPieceQuantity ?? 0)}
                otherQty={(row.newAcceptedReturnedOtherQuantity ?? 0) + (row.newRejectedReturnedOtherQuantity ?? 0)}
                otherUnitName={row.otherUnitName}
              />
              { batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }

            </div>
          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "returnValue",
        width: 150,
        textAlign: "left",
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={truncateToTwoDecimals(row.returnValue ?? "-")}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.returnValue ?? "-")}</span>
              </Box>
            </Tooltip>
          )
        }
      },
    ],
  }

}


export const ViewPrimaryReturnWithoutGRNConfig = (
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: ViewReturnSkuData) => void

) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;

  return {
    columns: [
      {
        headerName: "skuNameAndCode",
        mappedValue: "skuCode",
        width: 180,
        renderHeader: (value: any) => (
          <Box display="flex" sx={{ flexDirection: "column", alignItems: "left" }}>
              <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                <span>{"SKU Name"}</span>
                <span className="customTableInfo_marginTopNegative">{"& Code"}</span>
              </Box>
            </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={`${row?.skuName} - ${value}`}>
              <Box className="sku_name_truncate_text">
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{ ...TruncatedTextUptoLine(1), fontWeight: 500, fontSize: "12px" }}>
                    {row?.skuName}
                  </span>
                  <span style={{ ...TruncatedTextUptoLine(1), fontSize: "11px", color: "#666" }}>
                    {value}
                  </span>
                </div>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "Pack Type",
        mappedValue: "brand",
        width: 100,
        textAlign: "left",
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box>
              <span>{"Brand"}</span>
            </Box>
          </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Box className="sku_name_truncate_text">
              <span>{row.brand}</span>
            </Box>
          );
        },
      },
       ...(batchIdConfiguration
        ? [
            {
              headerName: "Batch Id",
              mappedValue: "batchId",
              width: 120,
              canOpen: true,
              renderHeader: (value: any) => (
                <Box display={"flex"} flexDirection={"column"}>
                  <span>{"Batch ID"}</span>
                </Box>
              ),
              renderCell: (value: any, row: SkuData) => {
                if (row?.batches) return (
                   <div
                    className="view-discounts-container"
                    style={{userSelect: "none"}}
                  >
                    <span >View Batch IDs</span>
                    <CircledRight style={{ width: "10px" }} />
                  </div>
                )
                return (
                  <Tooltip title={value}>
                    <Box className="sku_name_truncate_text">
                      <span style={TruncatedTextUptoLine(2)}>
                        {value ?? "-"}
                      </span>
                    </Box>
                  </Tooltip>
                );
              },
            },
          ]
        : [
            {
              headerName: "PTD",
              mappedValue: "priceToRetailer",
              width: 100,
              textAlign: "left",
              renderCell: (value: any, row: any) => {
                return (
                  <span>{`${currency} ${truncateToTwoDecimals(row.priceToRetailer)}`}</span>
                )
              }
            },
          ]
        ),
      {
        headerName: "Return Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: ViewReturnSkuData) => {
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
              <PrimaryReturnQtyCell
                csQty={row.totalReturnedCases ?? 0}
                pcQty={row.totalReturnedPieces ?? 0}
                otherQty={row.totalReturnedOtherUnits ?? 0}
                otherUnitName={row.otherUnitName}
              />
              { !batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }
            </div>
          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "actualAmount",
        textAlign: "left",
        width: 150,
        renderCell: (value: any, row: ViewReturnSkuData) => {
          return (
            <span>{`${currency} ${truncateToTwoDecimals(row.totalReturnedValue ?? 0)}`}</span>
          )
        }

      },
    ],
  };
};


export const ViewPrimaryReturnConfig = (
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: ViewReturnSkuData) => void

) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;

  return {
    columns: [
      {
        headerName: "skuNameAndCode",
        mappedValue: "skuCode",
        width: 180,
        renderHeader: (value: any) => (
          <Box display="flex" sx={{ flexDirection: "column", alignItems: "left" }}>
              <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                <span>{"SKU Name"}</span>
                <span className="customTableInfo_marginTopNegative">{"& Code"}</span>
              </Box>
            </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={`${row?.skuName} - ${value}`}>
              <Box className="sku_name_truncate_text">
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{ ...TruncatedTextUptoLine(1), fontWeight: 500, fontSize: "12px" }}>
                    {row?.skuName}
                  </span>
                  <span style={{ ...TruncatedTextUptoLine(1), fontSize: "11px", color: "#666" }}>
                    {value}
                  </span>
                </div>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "Pack Type",
        mappedValue: "brand",
        width: 100,
        textAlign: "left",
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box>
              <span>{"Brand"}</span>
            </Box>
          </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
            <Box className="sku_name_truncate_text">
              <span>{row.brand}</span>
            </Box>
          );
        },
      },
       ...(batchIdConfiguration
        ? [
            {
              headerName: "Batch Id",
              mappedValue: "batchId",
              width: 120,
              canOpen: true,
              renderHeader: (value: any) => (
                <Box display={"flex"} flexDirection={"column"}>
                  <span>{"Batch ID"}</span>
                </Box>
              ),
              renderCell: (value: any, row: SkuData) => {
                if (row?.batches) return (
                   <div
                    className="view-discounts-container"
                    style={{userSelect: "none"}}
                  >
                    <span >View Batch IDs</span>
                    <CircledRight style={{ width: "10px" }} />
                  </div>
                )
                return (
                  <Tooltip title={value}>
                    <Box className="sku_name_truncate_text">
                      <span style={TruncatedTextUptoLine(2)}>
                        {value ?? "-"}
                      </span>
                    </Box>
                  </Tooltip>
                );
              },
            },
          ]
        : [
            {
              headerName: "PTD",
              mappedValue: "priceToRetailer",
              width: 100,
              textAlign: "left",
              renderCell: (value: any, row: any) => {
                return (
                  <span>{`${currency} ${truncateToTwoDecimals(row.priceToRetailer)}`}</span>
                )
              }
            },
          ]
        ),
      {
        headerName: "Sold Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: ViewReturnSkuData) => {
          return (
            <PrimaryReturnQtyCell
              csQty={row.totalInvoicedCases ?? 0}
              pcQty={row.totalInvoicedPieces ?? 0}
              otherQty={row.totalInvoicedOtherUnits ?? 0}
              otherUnitName={row.otherUnitName}
            />
          )
        }
      },
      {
        headerName: "Return Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: ViewReturnSkuData) => {
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
              <PrimaryReturnQtyCell
                csQty={row.totalReturnedCases ?? 0}
                pcQty={row.totalReturnedPieces ?? 0}
                otherQty={row.totalReturnedOtherUnits ?? 0}
                otherUnitName={row.otherUnitName}
              />
              { !batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }
            </div>
          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "actualAmount",
        textAlign: "left",
        width: 150,
        renderCell: (value: any, row: ViewReturnSkuData) => {
          return (
            <span>{`${currency} ${truncateToTwoDecimals(row.totalReturnedValue ?? 0)}`}</span>
          )
        }

      },
    ],
  };
};


export const ViewPrimaryReturnExpandedRowConfig = (
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: ViewReturnBatchDetails) => void
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;
  return {
    columns: [
      {
        headerName: "Batch ID",
        mappedValue: "batchId",
        width: 150,
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value ?? "-"}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "MRP",
        mappedValue: "mrp",
        width: 130,
        textAlign: "left",
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.mrp)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
      {
        headerName: "PTD",
        mappedValue: "priceToRetailer",
        width: 130,
        textAlign: "left",
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.priceToRetailer)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
      {
        headerName: "Return Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: ViewReturnBatchDetails) => {
          //Need to populate with the quantity added from user. these are the quantity from previous generate returns
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
              <PrimaryReturnQtyCell 
                csQty={row.totalReturnedCaseQuantity ?? 0}
                pcQty={row.totalReturnedPieceQuantity ?? 0}
                otherQty={row.totalReturnedOtherQuantity ?? 0}
                otherUnitName={row.otherUnitName}
              />
              { batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }
            </div>
          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "returnValue",
        width: 150,
        textAlign: "left",
        renderCell: (value: any, row: any) => {
          return (
            <Tooltip title={truncateToTwoDecimals(row.returnValue ?? "-")}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.returnValue ?? "-")}</span>
              </Box>
            </Tooltip>
          )
        }
      },
    ],
  }

}


export const CreatePrimaryReturnWithoutGRNConfig = (
  handleRemove: (paramRow: any) => void,
  handleRedirect: (rowData: SkuDataWithoutGRN) => void,
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: SkuDataWithoutGRN) => void
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;

  return {
    columns: [

      {
        headerName: "skuNameAndCode",
        mappedValue: "skuCode",
        width: 180,
        renderHeader: (value: any) => (
          <Box display="flex" sx={{ flexDirection: "column", alignItems: "left" }}>
              <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                <span>{"SKU Name"}</span>
                <span className="customTableInfo_marginTopNegative">{"& Code"}</span>
              </Box>
            </Box>
        ),
        renderCell: (value: any, row: SkuDataWithoutGRN) => {
          return (
            <Tooltip title={`${row?.skuName} - ${value}`}>
              <Box className="sku_name_truncate_text">
                <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                  <span style={{ ...TruncatedTextUptoLine(1), fontWeight: 500, fontSize: "12px" }}>
                    {row?.skuName}
                  </span>
                  <span style={{ ...TruncatedTextUptoLine(1), fontSize: "11px", color: "#666" }}>
                    {value}
                  </span>
                </div>
              </Box>
            </Tooltip>
          );
        },
      },
       ...(batchIdConfiguration
        ? [
            {
              headerName: "Batch Id",
              mappedValue: "batchId",
              width: 120,
              canOpen: true,
              renderHeader: (value: any) => (
                <Box display={"flex"} flexDirection={"column"}>
                  <span>{"Batch ID"}</span>
                </Box>
              ),
              renderCell: (value: any, row: SkuDataWithoutGRN) => {
                if (row?.batches) return (
                   <div
                    className="view-discounts-container"
                    style={{userSelect: "none"}}
                  >
                    <span >View Batch IDs</span>
                    <CircledRight style={{ width: "10px" }} />
                  </div>
                )
                return (
                  <Tooltip title={value}>
                    <Box className="sku_name_truncate_text">
                      <span style={TruncatedTextUptoLine(2)}>
                        {value ?? "-"}
                      </span>
                    </Box>
                  </Tooltip>
                );
              },
            },
          ]
        : [
            {
              headerName: "PTD",
              mappedValue: "priceToRetailer",
              width: 100,
              textAlign: "left",
              renderCell: (value: any, row: SkuDataWithoutGRN) => {
                return (
                  <span>{`${currency} ${truncateToTwoDecimals(row.priceTodistributor ?? 0)}`}</span>
                )
              }
            },
          ]
        ),
      {
        headerName: "Damage Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: SkuDataWithoutGRN) => {
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
            <PrimaryReturnQtyCell
              csQty={row.totalReturnedCases ?? 0}
              pcQty={row.totalReturnedPieces ?? 0}
              otherQty={row.totalReturnedOtherUnits ?? 0}
              otherUnitName={row.otherUnitName}
            />
            <div style={{ marginLeft: "5px", cursor: 'pointer', display: 'flex', gap: '8px', alignItems: 'center' }}
            >
              <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={() => handleRedirect(row)}>
                <RenderSvg name={"viewAndEditIcon"} customStyles={{width: "18px"}} />
              </button>
              { !batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }
            </div>
            </div>

          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "actualAmount",
        textAlign: "left",
        width: 150,
        renderCell: (value: any, row: SkuDataWithoutGRN) => {
          return (
            <span>{`${currency} ${truncateToTwoDecimals(row?.totalReturnedValue ?? 0)}`}</span>
          )
        }

      },
      {
          headerName: "",
          mappedValue: "",
          width: 35,
          renderCell: (value: any, row: any) => {
            return (
              <button
                className="view_order_manage_order_table_button"
                onClick={() => {
                  handleRemove(row);
                }}
                title="Remove row"
              >
                <SubtractIcon style={{ width: "16px", height: "16px" }} />
              </button>
            ); 
          }
        }
    ],
  };
};




export const CreatePrimaryReturnWithoutGRNExpandedRowConfig = (
  handleClickInfo: (e: React.MouseEvent<HTMLElement>,rowData: BatchDetailsWithOutGRN) => void
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimaryReturn,caseUnitLabelPrimaryReturn,otherUnitLabelPrimaryReturn,currency, batchIdConfiguration } = ConfigDictionary;
  return {
    columns: [
      {
        headerName: "Batch ID",
        mappedValue: "batchId",
        width: 150,
        renderCell: (value: any, row: BatchDetailsWithOutGRN) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value ?? "-"}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "MRP",
        mappedValue: "mrp",
        width: 130,
        textAlign: "left",
        renderCell: (value: any, row: BatchDetailsWithOutGRN) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.mrp)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
      {
        headerName: "PTD",
        mappedValue: "priceTodistributor",
        width: 130,
        textAlign: "left",
        renderCell: (value: any, row: BatchDetailsWithOutGRN) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.priceTodistributor)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
      {
        headerName: "Damage Qty",
        mappedValue: "returnedCaseQty,returnedPieceQty,returnedOtherQty",
        width: 180,
        textAlign: "left",
        renderCell: (value: any, row: BatchDetailsWithOutGRN) => {
          //Need to populate with the quantity added from user. these are the quantity from previous generate returns
          return (
            <div style={{display: "flex", alignItems: "center", gap: "4px"}}>

              <PrimaryReturnQtyCell
                csQty={row.totalReturnedCaseQuantity}
                pcQty={row.totalReturnedPieceQuantity}
                otherQty={row.totalReturnedOtherQuantity}
                otherUnitName={row.otherUnitName}
              />
              { batchIdConfiguration &&
                <button className="MultiQtyCell_edit-button" style={{padding: "0px"}} onClick={(e) => handleClickInfo(e, row)}>
                  <RenderSvg name="infoIconMSO" customStyles={{width: "18px"}}/>
                </button>
              }

            </div>
          )
        }
      },
      {
        headerName: "Return Value",
        mappedValue: "returnValue",
        width: 150,
        textAlign: "left",
        renderCell: (value: any, row: BatchDetailsWithOutGRN) => {
          return (
            <Tooltip title={truncateToTwoDecimals(row.returnValue ?? 0)}>
              <Box className="sku_name_truncate_text">
                <span >{currency} {truncateToTwoDecimals(row.returnValue ?? 0)}</span>
              </Box>
            </Tooltip>
          )
        }
      },
    ],
  }

}

export const CreatePrimaryReturnWithoutGRNMetadata = (data: any): any[] => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {caseUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn} = ConfigDictionary;
  const currency = ConfigDictionary?.currency ?? "";
  const metaData: any[] = [
    {
      keys: "returnDate",
      label: "Return Date",
      index: 1,
    },
   {
      keys: "companySupplier",
      label: "Company Supplier",
      index: 4,
    },
    {
      key: "totalReturnedQuantity",
      label: "Total Returned Quantity",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <p>
          {caseUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              {data?.totalReturnedCases ?? 0}{" "}
              <span  >{caseUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {otherUnitLabelPrimaryReturn && (
            <span  style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedOtherUnits ?? 0}{" "}
              <span>{otherUnitLabelPrimaryReturn}</span>
            </span>
          )}
          {packUnitLabelPrimaryReturn && (
            <span style={{color: "#B96D16", fontWeight: 500}}>
              , {data?.totalReturnedPieces ?? 0} {" "}
              <span>{packUnitLabelPrimaryReturn}</span>
            </span>
          )}
        </p>
      ),
    },
    {
      key: "totalReturnValue",
      label: "Total Returned Value",
      index: 5,
      render: "Jsx",
      renderJsx: (value: any) => (
        <span style={{ fontWeight: 500, color: "#1b7713"  }}>
          {formatAmount(data?.totalReturnedValue ?? 0, currency)}
        </span>
      ),
    }
  ];

  return metaData;
};
